import FreelancerOnboardingFlow from "@/components/freelancer/Freelancer-Onboarding";

const FreelancerOnboarding = () => {
  return <FreelancerOnboardingFlow />;
};

export default FreelancerOnboarding;
